import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	name: {
		id: 'admin-pages-issue-types-directory.table.head.name',
		defaultMessage: 'Name',
		description: 'Header for "name" column of table',
	},
	hierarchyLevel: {
		id: 'admin-pages-issue-types-directory.table.head.hierarchy-level',
		defaultMessage: 'Hierarchy Level',
		description: 'Header for "hierarchy level number" column of table',
	},
	relatedSchemes: {
		id: 'admin-pages-issue-types-directory.table.head.related-schemes',
		defaultMessage: 'Related Schemes',
		description: 'Header for "related schemes" column of table',
	},
});
